import { useConfigurationSelector } from "../context/ConfigurationReduxContext";
import { getSelectorDefaults } from "../reducers/selectors";
/**
 * Returns defaults for selector options
 *
 * These are used for any new request that is sent to the backend
 *
 * @private Do not use outside internal packages
 *
 * @returns Defaults for selector options
 */
export function useSelectorOptionDefaults() {
    const defaults = useConfigurationSelector(getSelectorDefaults);
    return defaults;
}
//# sourceMappingURL=useSelectorOptionDefaults.js.map